export default "__VITE_ASSET__BMeluN1M__"